type AdEventHandler = (moltenBundle: any) => void

export function queueAdEvent (eventHandler: AdEventHandler) {
  // If we're not in the browser, return immediately
  if (typeof window === 'undefined') {
    return
  }

  window.GujAd = window.GujAd || {}
  window.GujAd.cmd = window.GujAd.cmd || []
  window.GujAd.cmd.push(() => {
    const MoltenBundle = window.MoltenBundle as any
    eventHandler(MoltenBundle)
  })
}
